import styled from "styled-components";

export const ShimmerWrapper = styled.div`
  box-shadow: 0 0 11px -1px rgb(229, 229, 229);
  margin-bottom: 0px;
  padding-bottom: 0px;
  margin-left: 0px;
  min-width: 286px;
  justify-content: center;
  form {
    margin-top: 30px;
    margin-left: 20px;
    margin-right: 20px;
    display: flex;
    flex-wrap: wrap;
    row-gap: 15px;
    column-gap: 10px;
    justify-content: space-between;
    align-items: stretch;
  }
  .basic-form-input {
    flex: auto;
    width: 47%;
  }

  @media only screen and (max-width: 768px) {
    border-radius: 0;
    padding: 0;
    box-shadow: none;

    .basic-form-input {
      width: 100%;
    }

    .basic-form-input-small {
      max-width: 48%;
    }
  }
`;
